function credits() {
    const page = document.querySelector('[data-credits-page]');

    if (!page) {
        return;
    }

    const packs = Array.from(page.querySelectorAll('[data-credit-pack]'));
    const buyButtons = Array.from(page.querySelectorAll('[data-credit-buy]'));
    const selectedCredits = Array.from(page.querySelectorAll('[data-selected-credits]'));
    const selectedPrices = Array.from(page.querySelectorAll('[data-selected-price]'));
    const modal = page.querySelector('[data-payment-modal]');
    const modalOpenButtons = Array.from(page.querySelectorAll('[data-payment-modal-open]'));
    let lastTrigger = null;

    const selectPack = (pack) => {
        packs.forEach((item) => {
            const selected = item === pack;
            item.classList.toggle('is-selected', selected);
            const state = item.querySelector('[data-pack-state]');
            if (state) state.childNodes[0].textContent = selected ? 'Selected ' : 'Select pack ';
        });
        const input = pack.querySelector('input[type="radio"]');
        if (input) input.checked = true;

        const amount = pack.querySelector('.art-credit-pack__amount strong');
        const price = pack.querySelector('.art-credit-pack__price');
        if (amount) selectedCredits.forEach((element) => { element.textContent = amount.textContent; });
        if (price) selectedPrices.forEach((element) => { element.innerHTML = price.innerHTML; });
        buyButtons.forEach((button) => {
            const provider = button.dataset.creditBuy;
            const checkoutUrl = provider === 'paypal'
                ? pack.dataset.checkoutPaypalUrl
                : (provider === 'stripe' ? pack.dataset.checkoutStripeUrl : pack.dataset.loginUrl);
            if (checkoutUrl) {
                button.href = checkoutUrl;
            }

            if (provider === 'paypal' && input && checkoutUrl) {
                button.dataset.productId = input.value;

                try {
                    const url = new URL(checkoutUrl, window.location.origin);
                    const checkoutAttemptId = url.searchParams.get('gwc_checkout_attempt');
                    if (checkoutAttemptId) button.dataset.checkoutAttemptId = checkoutAttemptId;
                } catch {
                    // Keep the server-rendered checkout metadata when the URL cannot be parsed.
                }
            }
        });
    };

    const openModal = (trigger) => {
        if (!modal) return;
        lastTrigger = trigger;

        if (window.growtypeModal && typeof window.growtypeModal.show === 'function') {
            window.growtypeModal.show(modal);
        } else if (window.bootstrap && window.bootstrap.Modal) {
            window.bootstrap.Modal.getOrCreateInstance(modal).show();
        }
    };

    packs.forEach((pack) => {
        const selectButton = pack.querySelector('[data-pack-select]');
        if (selectButton) {
            selectButton.addEventListener('click', () => {
                selectPack(pack);
                openModal(selectButton);
            });
        }
        const input = pack.querySelector('input[type="radio"]');
        if (input) input.addEventListener('change', () => selectPack(pack));
    });

    modalOpenButtons.forEach((button) => button.addEventListener('click', () => openModal(button)));
    if (modal) {
        modal.addEventListener('hidden.bs.modal', () => {
            if (lastTrigger) lastTrigger.focus();
        });
    }
}

export {credits};
